import useSurveyController from '../shared/use-survey-controller';

export default function useQuizletController() {
  // Use the updated quizlet version with single selection for cancer question
  const surveyVersion = 'quizlet1.2.0';

  const surveyController = useSurveyController({
    surveyVersion,
    onModalViewed: () => {
      // Turn off analytics for the quizlet survey. Should use page view instead.
      return;
    },
  });

  return surveyController
}
